import { FC } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Divider
} from '@material-ui/core';
import 'react-loading-skeleton/dist/skeleton.css'
import { InputField } from '../input-field';
import { DateField } from '../date-field';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store';
import { useDispatch, useSelector } from "react-redux";
import { updateField } from '../../slices/moveSlice';

export const WizardDetails: FC = () => {
  const { t } = useTranslation();

  const move = useSelector((state: RootState) => state.move);
  const dispatch = useDispatch();

  // End date can't be before start date — robustly parse the start date
  // (Date / ISO / dd-mm-yyyy) to use as the End date picker's minDate.
  const toDate = (v: any): Date | undefined => {
    if (!v) return undefined;
    if (v instanceof Date) return Number.isNaN(v.getTime()) ? undefined : v;
    const native = new Date(v);
    if (!Number.isNaN(native.getTime())) return native;
    const parts = String(v).split(/[/.]/);
    if (parts.length === 3) {
      const d = new Date(+parts[2], +parts[1] - 1, +parts[0]);
      if (!Number.isNaN(d.getTime())) return d;
    }
    return undefined;
  };
  const startMinDate = toDate(move.startDate);

  return (
    <Card
      // variant="outlined"
      sx={{ backgroundColor: 'background.default' }}
    // {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            xs={12}
          >
            <div>
              <Grid
                container
                spacing={2}
              >

                {/* Start / End dates moved here from the first (essentials) page. */}
                <Grid item xs={12} md={6}>
                  <DateField
                    fullWidth
                    label={t('start_date')}
                    name="startDate"
                    onChange={(date) => dispatch(updateField({ field: 'startDate', value: date }))}
                    value={move.startDate}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <DateField
                    fullWidth
                    label={t('end_date')}
                    name="finishDate"
                    minDate={startMinDate}
                    shouldDisableDate={startMinDate
                      ? (day: Date) => {
                          const d = new Date(day); d.setHours(0, 0, 0, 0);
                          const min = new Date(startMinDate); min.setHours(0, 0, 0, 0);
                          return d.getTime() < min.getTime();
                        }
                      : undefined}
                    onChange={(date) => dispatch(updateField({ field: 'finishDate', value: date }))}
                    value={move.finishDate}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <InputField
                    // error={Boolean(formik.touched.kpi && formik.errors.kpi)}
                    fullWidth
                    // helperText={formik.touched.kpi && formik.errors.kpi}
                    label={t('kpi')}
                    name="kpi"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'kpi', value: e.target.value }))}
                    value={move.kpi}
                    placeholder=""
                    multiline
                    rows={2}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <InputField
                    // error={Boolean(formik.touched.descriptionOfTheGoal && formik.errors.descriptionOfTheGoal)}
                    fullWidth
                    // helperText={formik.touched.descriptionOfTheGoal && formik.errors.descriptionOfTheGoal}
                    label={'Goal that this Move must achieve (for GDPM)'}
                    name="descriptionOfTheGoal"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'descriptionOfTheGoal', value: e.target.value }))}
                    value={move.descriptionOfTheGoal}
                    placeholder=""
                    multiline
                    rows={2}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <DateField
                    fullWidth
                    label={'Goal due date (for GDPM)'}
                    name="goalDate"
                    placeholder="yyyy/mm/dd"
                    onChange={(date) => dispatch(updateField({ field: 'goalDate', value: date }))}
                    value={move.goalDate}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <InputField
                    // error={Boolean(formik.touched.kpi && formik.errors.kpi)}
                    fullWidth
                    // helperText={formik.touched.kpi && formik.errors.kpi}
                    label={'Key Performance Indicators (KPIs) to verify that the goal has been reached'}
                    name="kpi"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'kpi', value: e.target.value }))}
                    value={move.kpi}
                    placeholder=""
                    multiline
                    rows={2}
                  />
                </Grid>

                {/* {formik.errors.submit && (
                    <Grid
                      item
                      xs={12}
                    >
                      <FormHelperText error>
                        {formik.errors.submit}
                      </FormHelperText>
                    </Grid>
                  )} */}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};